import React from 'react';
const Electrician = () => <div className="service-page"><h1>Electrician</h1><p>Find trusted electricians for all your repair and installation needs.</p></div>;
export default Electrician;
